module.exports = __webpack_public_path__ + "img/overview_w.05a3c18f.svg";